module.exports = __webpack_public_path__ + "static/img/sleep01.a270a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/sleep01.png
// module id = KfzK
// module chunks = 1